import {Action} from '@ngrx/store';
import * as _ from 'lodash';
import {GroupRole} from '../models/groupe-role';
import {userContextActionTypes} from '../actions/user-context';
import {groupRolesActionTypes, LoadGroupRolesSuccessAction} from '../actions/group-roles';

export interface GroupRolesState {
  array: GroupRole[];
}

const initialState: GroupRolesState = {
  array: []
};

export function groupRolesReducer(state: GroupRolesState = initialState, action: Action): GroupRolesState {
  switch (action.type) {
    case groupRolesActionTypes.LOAD:
      return handleLoadAction();
    case groupRolesActionTypes.LOAD_SUCCESS:
      return handleLoadSuccessAction(state, action);
    case groupRolesActionTypes.LOAD_FAIL:
      return handleLoadFailAction(state);
    case userContextActionTypes.CHANGE_CLIENT:
      return handleChangeClientAction();
    default:
      return state;
  }
}

function handleLoadAction(): GroupRolesState {
  return initialState;
}

function handleLoadSuccessAction(state: GroupRolesState, action: LoadGroupRolesSuccessAction): GroupRolesState {
  const newState = _.clone(state);
  newState.array = action.payload;
  return newState;
}

function handleLoadFailAction(state: GroupRolesState): GroupRolesState {
  const newState = _.clone(state);
  newState.array = [];
  return newState;
}

function handleChangeClientAction(): GroupRolesState {
  return { array: [] };
}

export const groupRolesSelectors = {
  array: (state: GroupRolesState) => _.get(state, 'array', [])
};
